// Unsorted's highest snap point, which it rises to while an element inside it is edited
export const INBOX_EXPANDED_SNAP_POINT = 0.9;
